import { endOfDay } from "date-fns";


export const getCustomDateRange = (
  customDateRange: [Date | null, Date | null]
) => {
  return (
    customDateRange.length === 2 && {
      startDate: customDateRange?.at(0)
        ? customDateRange?.at(0)?.toISOString()
        : "",
      endDate: customDateRange?.at(1)
        ? endOfDay(customDateRange.at(1) as Date).toISOString()
        : "",
    }
  );
};
